module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ieditorreview"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "header-tips",
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 16,
      "lg": 10
    }
  }, [(_vm.newContent.edittime) ? _c('span', [_vm._v("上次保存于" + _vm._s(_vm.newContent.edittime))]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6,
      "lg": 4
    }
  }, [_c('span', {
    staticClass: "header-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "disabled": _vm.filters.done
    },
    on: {
      "click": function($event) {
        _vm.reedit(_vm.newContent.id)
      }
    }
  }, [_vm._v("继续编辑")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.filters.done
    },
    on: {
      "click": function($event) {
        _vm.releaseNews(_vm.newContent.id)
      }
    }
  }, [_vm._v("发布")])], 1)])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('div', {
    staticClass: "review-content"
  }, [_c('div', {
    staticClass: "news-box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('span', {
    staticClass: "new-type fs-label"
  }, [_vm._v(_vm._s(_vm.formatCategory))]), _vm._v(" "), _c('span', {
    staticClass: "hot-level fs-label"
  }, [_vm._v(_vm._s(_vm.formatHotIndex))])]), _vm._v(" "), _c('div', {
    staticClass: "box-title"
  }, [_c('h1', {
    staticClass: "fs-title"
  }, [_vm._v(_vm._s(_vm.newContent.title))])]), _vm._v(" "), _c('div', {
    staticClass: "box-author fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.newContent.date) + " ")]), _vm._v(" "), (_vm.newContent.editorname) ? _c('span', [_vm._v(" 编:" + _vm._s(_vm.newContent.editorname))]) : _vm._e(), _vm._v(" "), (_vm.newContent.hostname) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.hostname))]) : (_vm.newContent.host) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.host))]) : _vm._e(), _vm._v(" "), (_vm.newContent.verifiername) ? _c('span', [_vm._v(" 审:" + _vm._s(_vm.newContent.verifiername))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 20,
      "sm": 20,
      "md": 12,
      "lg": 10
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newContent.cover),
      expression: "newContent.cover"
    }],
    staticClass: "box-image",
    attrs: {
      "src": _vm.newContent.cover
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('p', {
    staticClass: "box-text fs-text"
  }, [_vm._v(_vm._s(_vm.newContent.content))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-source fs-text"
  }, [_c('span', [_vm._v("新闻来源:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatSourcefrom))])]), _vm._v(" "), _c('div', {
    staticClass: "box-origin fs-text"
  }, [_c('span', [_vm._v("原文地址:")]), _c('a', {
    attrs: {
      "href": _vm.newContent.sourceurl,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "link-url"
  }, [_vm._v(_vm._s(_vm.newContent.sourceurl))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-foot fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.formatLabels2))])])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f9927b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ieditor/review.vue
// module id = 772
// module chunks = 6